export default {
	"lang": "en",
	"page-title": "Market Analysis",
}